import { render } from "./AddTeamMember.vue?vue&type=template&id=55b45b48"
import script from "./AddTeamMember.vue?vue&type=script&lang=js"
export * from "./AddTeamMember.vue?vue&type=script&lang=js"
script.render = render

export default script